import useApi from "./useApi";

export interface TrackEvent {
  category: string;
  action: string;
  entityType?: string;
  entityId?: string;
  entityName?: string;
  detail?: Record<string, unknown>;
}

/**
 * useActivityLog — call track() after successful mutations that go through
 * the V10 messaging API (workflows, rules, bots, etc.) rather than our backend.
 * Fire-and-forget: failures are silently ignored so they never block the user.
 */
export default function useActivityLog() {
  const api = useApi();

  function track(event: TrackEvent) {
    api.admin
      .post("ActivityLog/track", event)
      .then(async (res) => {
        if (!res.ok) {
          const body = await res.text().catch(() => "");
          console.error(
            "[ActivityLog] track rejected HTTP",
            res.status,
            body.slice(0, 200)
          );
        }
      })
      .catch((err) => {
        // Never block the UI — but surface failures in DevTools so they don't vanish silently
        console.error("[ActivityLog] track failed:", err);
      });
  }

  return { track };
}
